import React, { useMemo, useState, useRef, useEffect, Fragment } from 'react'
import CustomTable from './customTable';
import Breadcrumbs from "components/Common/Breadcrumb";
import Swal from 'sweetalert2';
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Button,
    Input,
    Table,
	CardHeader
} from "reactstrap";
import { ModuleName, ModuleCode } from './accessRightlistCol';
import { RoleList, AccessRights, Modules } from "common/data/constants"
import CustomSelect from 'components/Common/custom-select';
import { ChevronRight, ChevronDown ,ShieldCheck,Folder, File,LayoutDashboard, ListChecks, Settings } from "lucide-react";
import TableContainer from 'components/Common/TableContainer';
import "./role-access.css";
import { useDispatch, useSelector } from 'react-redux';
import { useAuthUserDetails } from 'components/Common/getAuthUserDetails';
import { fetchAccountRoles, fetchRolesAccessRights, resetAll, saveRoleAccessRights } from 'store/actions';
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";

function RolesAccessRights() {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  useEffect(() => {
      const rights = getAccessRights(location.pathname, history);
      setAccessRight(rights?.data);
  }, [location]);
  const { canRead, canCreate, canEdit, canDelete, canApprove } = useButtonAccess(accessRight);
	const dispatch = useDispatch();
	const [authDetails, setAuthDetails] = useState(null);
	const {
		roles,
		accessRights,
		loading,
		success,
		error,
	} = useSelector((state) => ({
		roles: state.LoginCreation?.roles ?? [],
		accessRights: state.LoginCreation?.accessRights ?? [],

		loading: state.LoginCreation?.loading,
		error: state.LoginCreation?.error,
		success: state.LoginCreation?.success,
	}));
    const [option, setOptions] = useState([]);
    const [selectedValue, setSelectedValue] = useState(null);
    const [data, setData] = useState([])
    const [selectAllChecked, setSelectAllChecked] = useState(false);

	useEffect(() => {
		const authUserDetails = useAuthUserDetails();
		setAuthDetails(authUserDetails[0])
		const unitId = authUserDetails[0].unit_id
		dispatch(resetAll())
		dispatch(fetchAccountRoles(unitId));
	}, [dispatch]);

	useEffect(() => {
		if (roles?.length) {
			setOptions(roles);
		}
	}, [roles]);

  useEffect(() => {
      if (success) {
          setData([]);
          setSelectedValue('')
          setSelectAllChecked(false)
      }
  }, [authDetails, success, dispatch]);

	useEffect(() => {
		if (accessRights?.length) {
			// setData(buildHierarchy(accessRights));
       const hierarchy = buildHierarchy(accessRights);
      setData(hierarchy);

      // ✅ Automatically expand all modules with any checked access
      const expandedNodes = getExpandedNodes(hierarchy);
      setExpanded(expandedNodes);
		}else{
			setData([])
		}
	}, [accessRights]);

	const onSwitchChange = (e) => {
		const checked = e.target.checked;
		setSelectAllChecked(checked);

		// Define all permission keys
		const permissionKeys = [
			"read_access",
			"create_access",
			"edit_access",
			"approve_access",
			"delete_access",
		];

		// Recursive update function for all nested levels
		const updateAllPermissions = (items) =>
			items.map((item) => {
			const updatedItem = { ...item };

			// Set all permission keys based on toggle state
			permissionKeys.forEach((key) => {
				updatedItem[key] = checked;
			});

			// Recursively apply to children
			if (item.children?.length) {
				updatedItem.children = updateAllPermissions(item.children);
			}

			return updatedItem;
			});

		// Update data
		setData(updateAllPermissions(data));
	};

  const [expanded, setExpanded] = useState({});

  const toggleExpand = (id) => {
    setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
  };

//   // Build hierarchy (Modules → Screens)
//   const buildHierarchy = (data) => {
//     const map = {};
//     const roots = [];

//     data.forEach((item) => {
//       map[item.child_second_module_id] = { ...item, children: [] };
//     });

//     data.forEach((item) => {
//       if (item.parent_id && map[item.parent_id]) {
//         map[item.parent_id].children.push(map[item.child_second_module_id]);
//       } else {
//         roots.push(map[item.child_second_module_id]);
//       }
//     });

//     return roots;
//   };

// Build hierarchy dynamically from API data (Parent → Child → Sub-child)

  

  // Checkbox toggle logic (parent → child)
//   const handleCheckboxChange = (id, key, checked, nodes = data) => {
//   const updateNodes = (items) =>
//     items.map((item) => {
//       if (item.child_second_module_id === id) {
//         let updated = { ...item, [key]: checked };

//         // 🔹 Auto-check View when Create / Modify / Approve / Delete is toggled ON
//         if (
//           checked &&
//           ["create_access", "edit_access", "approve_access", "delete_access"].includes(key)
//         ) {
//           updated.read_access = true;
//         }

//         // 🔹 If unchecking View, also uncheck all other permissions
//         if (!checked && key === "read_access") {
//           updated = {
//             ...updated,
//             create_access: false,
//             edit_access: false,
//             approve_access: false,
//             delete_access: false,
//           };
//         }

//         // 🔹 Propagate to children if any
//         if (item.children?.length) {
//           updated.children = item.children.map((child) =>
//             updateChildCheckbox(child, key, checked)
//           );
//         }
//         return updated;
//       } else if (item.children?.length) {
//         return { ...item, children: updateNodes(item.children) };
//       }
//       return item;
//     });

//   setData(updateNodes(nodes));
// };

// const updateChildCheckbox = (child, key, checked) => {
//   let updated = { ...child, [key]: checked };

//   // Auto-check read_access for child as well
//   if (
//     checked &&
//     ["create_access", "edit_access", "approve_access", "delete_access"].includes(key)
//   ) {
//     updated.read_access = true;
//   }

//   // If unchecking view, uncheck others
//   if (!checked && key === "read_access") {
//     updated = {
//       ...updated,
//       create_access: false,
//       edit_access: false,
//       approve_access: false,
//       delete_access: false,
//     };
//   }

//   return {
//     ...updated,
//     children:
//       child.children?.map((c) => updateChildCheckbox(c, key, checked)) || [],
//   };
// };

// const renderRow = (item, level = 0) => {
//   const levelStyles = [
//     "bg-gradient-to-r from-blue-50 to-blue-100 font-semibold border-l-4 border-blue-500 text-dark shadow-sm", // Module
//     "bg-gradient-to-r from-gray-50 to-gray-100 text-dark border-l-2 border-gray-400", // Screen
//     "bg-white text-muted border-l border-gray-300", // Sub-screen
//   ];

// 	const getIcon = (level) => {
// 		switch (level) {
// 			case 0:
// 			return <LayoutDashboard size={18} className="text-purple-600" />; // Top-level module
// 			case 1:
// 			return <ListChecks size={17} className="text-indigo-500" />; // Menu or screen
// 			case 2:
// 			default:
// 			return <Settings size={16} className="text-gray-600" />; // Sub-menu or action
// 		}
// 	};

//   return (
//     <Fragment key={item.child_second_module_id}>
//       <tr className={`align-middle ${levelStyles[level] || ""} transition-all duration-200 hover:shadow-md hover:scale-[1.01]`}>
//         <td className="py-3 cursor-pointer tree-connector">
//           <div 
//             className={`d-flex align-items-center gap-3 indent-level-${level}`} 
//             onClick={() => toggleExpand(item.child_second_module_id)}
//             title={`Expand ${item.child_second_module}`}
//           >
//             {item.children?.length > 0 &&
//               (expanded[item.child_second_module_id] ? (
//                 <ChevronDown size={16} className="text-primary transition-transform" />
//               ) : (
//                 <ChevronRight size={16} className="text-primary transition-transform" />
//               ))}
//             {getIcon(level)}
//             <span className="font-medium">{item.child_second_module}</span>
//           </div>
//         </td>

//         {[
//           "read_access",
//           "create_access",
//           "edit_access",
//           "approve_access",
//           "delete_access",
//         ].map((key) => (
//           <td key={key} className="text-center py-3">
//             <input
//               type="checkbox"
//               checked={!!item[key]}
//               className="form-check-input"
//               onChange={(e) =>
//                 handleCheckboxChange(
//                   item.child_second_module_id,
//                   key,
//                   e.target.checked
//                 )
//               }
//               aria-label={`${key.replace('_', ' ')} for ${item.child_second_module}`}
//             />
//           </td>
//         ))}
//       </tr>

//       {expanded[item.child_second_module_id] &&
//         item.children?.map((child) => renderRow(child, level + 1))}
//     </Fragment>
//   );
// };


// 🔹 Build tree hierarchy with access propagation
const buildHierarchy = (data) => {
  const uniqueData = Array.from(
    new Map(data.map((item) => [item.child_second_module_id, item])).values()
  );

  const parentMap = {};

  uniqueData.forEach((item) => {
    const parent = item.parent_module || "Others";
    const child = item.child_module || null;

    // Ensure parent exists
    if (!parentMap[parent]) {
      parentMap[parent] = {
        child_second_module_id: parent,
        child_second_module: parent,
        parent_module: null,
        isParent: true,
        children: [],
        read_access: false,
        create_access: false,
        edit_access: false,
        approve_access: false,
        delete_access: false,
      };
    }

    // Child group or direct screen
    if (child) {
      let childNode = parentMap[parent].children.find(
        (c) => c.child_module === child
      );

      if (!childNode) {
        childNode = {
          child_second_module_id: `${parent}_${child}`,
          child_second_module: child,
          child_module: child,
          parent_module: parent,
          isChildGroup: true,
          children: [],
          read_access: false,
          create_access: false,
          edit_access: false,
          approve_access: false,
          delete_access: false,
        };
        parentMap[parent].children.push(childNode);
      }

      childNode.children.push({ ...item });
    } else {
      parentMap[parent].children.push({ ...item });
    }
  });

  // Recursive upward propagation
  const propagateAccessUpwards = (node) => {
    if (!node.children?.length) return node;

    node.children = node.children.map(propagateAccessUpwards);
    const keys = [
      "read_access",
      "create_access",
      "edit_access",
      "approve_access",
      "delete_access",
    ];

    keys.forEach((key) => {
      node[key] = node.children.some((child) => !!child[key]);
    });

    return node;
  };

  return Object.values(parentMap).map((p) => propagateAccessUpwards(p));
};

// 🔹 Update checkbox handler
const handleCheckboxChange = (id, key, checked) => {
  const updateNodes = (items) =>
    items.map((item) => {
      let updatedItem = { ...item };

      if (item.child_second_module_id === id) {
        updatedItem[key] = checked;

        // Auto-enable read_access if other access checked
        if (
          checked &&
          ["create_access", "edit_access", "approve_access", "delete_access"].includes(key)
        ) {
          updatedItem.read_access = true;
        }

        // Auto-disable others if read_access unchecked
        if (!checked && key === "read_access") {
          updatedItem = {
            ...updatedItem,
            create_access: false,
            edit_access: false,
            approve_access: false,
            delete_access: false,
          };
        }

        // Propagate to children
        if (item.children?.length) {
          updatedItem.children = item.children.map((child) =>
            updateChildCheckbox(child, key, checked)
          );
        }
      } else if (item.children?.length) {
        const updatedChildren = updateNodes(item.children);

        const anyChildChecked = updatedChildren.some((child) =>
          ["read_access", "create_access", "edit_access", "approve_access", "delete_access"].some(
            (perm) => child[perm]
          )
        );

        updatedItem = {
          ...item,
          children: updatedChildren,
          read_access: anyChildChecked || item.read_access,
        };

        const anyCheckedForKey = updatedChildren.some((c) => c[key]);
        updatedItem[key] = anyCheckedForKey;
      }

      return updatedItem;
    });

  setData((prev) => updateNodes(prev));
};

// 🔹 Recursive child checkbox updater
const updateChildCheckbox = (child, key, checked) => {
  let updated = { ...child, [key]: checked };

  if (
    checked &&
    ["create_access", "edit_access", "approve_access", "delete_access"].includes(key)
  ) {
    updated.read_access = true;
  }

  if (!checked && key === "read_access") {
    updated = {
      ...updated,
      create_access: false,
      edit_access: false,
      approve_access: false,
      delete_access: false,
    };
  }

  if (child.children?.length) {
    updated.children = child.children.map((c) =>
      updateChildCheckbox(c, key, checked)
    );
  }

  return updated;
};

// 🔹 Auto-expand logic for default expanded modules
const getExpandedNodes = (nodes) => {
  const expandedNodes = {};

  const hasAnyAccess = (item) =>
    item.read_access ||
    item.create_access ||
    item.edit_access ||
    item.approve_access ||
    item.delete_access;

  const traverse = (items) => {
    items.forEach((item) => {
      if (item.children?.length) {
        const childHasAccess =
          item.children.some(hasAnyAccess) ||
          item.children.some((c) => traverse([c]));

        if (childHasAccess || hasAnyAccess(item)) {
          expandedNodes[item.child_second_module_id] = true;
        }

        traverse(item.children);
      }
    });
  };

  traverse(nodes);
  return expandedNodes;
};

// 🔹 Render row (UI)
const renderRow = (item, level = 0) => {
  const levelStyles = [
    "bg-gradient-to-r from-blue-50 to-blue-100 font-semibold border-l-4 border-blue-500 text-dark shadow-sm",
    "bg-gradient-to-r from-gray-50 to-gray-100 text-dark border-l-2 border-gray-400",
    "bg-white text-muted border-l border-gray-300",
  ];

  const getIcon = (level) => {
    switch (level) {
      case 0:
        return <LayoutDashboard size={18} className="text-purple-600" />;
      case 1:
        return <ListChecks size={17} className="text-indigo-500" />;
      default:
        return <Settings size={16} className="text-gray-600" />;
    }
  };

  return (
    <Fragment key={item.child_second_module_id || item.child_second_module}>
      <tr
        className={`align-middle ${
          levelStyles[level] || ""
        } transition-all duration-200 hover:shadow-md hover:scale-[1.01]`}
      >
        <td className="py-3 cursor-pointer tree-connector">
          <div
            className={`d-flex align-items-center gap-3 indent-level-${level}`}
            onClick={() => toggleExpand(item.child_second_module_id)}
            title={`Expand ${item.child_second_module}`}
          >
            {item.children?.length > 0 &&
              (expanded[item.child_second_module_id] ? (
                <ChevronDown size={16} className="text-primary transition-transform" />
              ) : (
                <ChevronRight size={16} className="text-primary transition-transform" />
              ))}
            {getIcon(level)}
            <span className="font-medium">{item.child_second_module}</span>
          </div>
        </td>

        {[
          "read_access",
          "create_access",
          "edit_access",
          "approve_access",
          "delete_access",
        ].map((key) => (
          <td key={key} className="text-center py-3">
            <input
              type="checkbox"
              checked={!!item[key]}
              className="form-check-input"
              onChange={(e) =>
                handleCheckboxChange(
                  item.child_second_module_id,
                  key,
                  e.target.checked
                )
              }
              aria-label={`${key.replace("_", " ")} for ${item.child_second_module}`}
            />
          </td>
        ))}
      </tr>

      {expanded[item.child_second_module_id] &&
        item.children?.map((child) => renderRow(child, level + 1))}
    </Fragment>
  );
};


const handleSave = async () => {
  if (!selectedValue?.value) {
    Swal.fire({
      icon: "warning",
      title: "Role not selected",
      text: "Please choose a role before saving access rights.",
      confirmButtonColor: "#7c3aed",
    });
    return;
  }

  const confirmResult = await Swal.fire({
    title: "Save Access Rights?",
    text: `Are you sure you want to save access rights for "${selectedValue.label}"?`,
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Yes, Save",
    cancelButtonText: "Cancel",
    confirmButtonColor: "#7c3aed",
    cancelButtonColor: "#6b7280",
  });

  if (!confirmResult.isConfirmed) {
    setSelectedValue(null);
    setData([]);
    setExpanded({});
    setSelectAllChecked(false);
    return;
  }

  try {
    // 🔹 Flatten the nested permission tree
    const flattenPermissions = (items) =>
      items.flatMap((item) => [
        {
          module_code: item.module_code || null,
          // parent_module: item.parent_module || null,
          // child_module: item.child_module || null,
          role_id: selectedValue.value,
          read_access: item.read_access ? "1" : "0",
          create_access: item.create_access ? "1" : "0",
          edit_access: item.edit_access ? "1" : "0",
          approve_access: item.approve_access ? "1" : "0",
          delete_access: item.delete_access ? "1" : "0",
        },
        ...(item.children?.length ? flattenPermissions(item.children) : []),
      ]);

    const allPermissions = flattenPermissions(data);

    // 🔹 Keep only items where module_code exists (non-null & non-empty)
    const validPermissions = allPermissions.filter(
      (perm) =>
        perm.module_code &&
        perm.module_code.trim() !== "" &&
        (perm.read_access === "1" ||
          perm.create_access === "1" ||
          perm.edit_access === "1" ||
          perm.approve_access === "1" ||
          perm.delete_access === "1")
    );

    if (validPermissions.length === 0) {
      Swal.fire({
        icon: "info",
        title: "No Permissions Selected",
        text: "Please select at least one valid screen permission to save.",
        confirmButtonColor: "#7c3aed",
      });
      return;
    }

    // 🔹 Prepare final payload (only valid module_code items)
    const payload = {
      lst_role_access_rights: { role: validPermissions },
      create_by: authDetails?.user_id,
      role_id: selectedValue.value,
    };

    // Example for API call
    const formData = new FormData();
    formData.append("lst_role_access_rights", JSON.stringify(payload.lst_role_access_rights));
    formData.append("create_by", payload.create_by);
    formData.append("role_id", payload.role_id);
    dispatch(saveRoleAccessRights(formData))
  } catch (error) {
    console.error("Save Error:", error);
    Swal.fire({
      icon: "error",
      title: "Error Occurred",
      text: "Unable to save access rights. Please try again later.",
      confirmButtonColor: "#7c3aed",
    });
  }
};

    return (
        <React.Fragment>

            <div className="page-content">
                <Container fluid>
                <Breadcrumbs title="Access Rights" breadcrumbItem="Access Rights" />
					<div className="permission-wrapper">
						<Row className="w-full">
							<Card className="permission-card">
								<CardHeader >
									<Row>
										{/* Role Selection */}
										<div className="col-md-4" style={{ flex: '1' }}>
											{/* <CustomSelect
												id="role"
												name="role"
												options={option.map(cat => ({
													value: cat.role_id.toString(),
													label: cat.role_name
												}))}
												value={selectedValue}
												onChange={(selectedOption) => {
													setSelectedValue(selectedOption);
													setSelectAllChecked(false);
													 if (selectedOption?.value) {
														dispatch(fetchRolesAccessRights(selectedOption.value));
													 }
												}}
												placeholder="Choose role"
												className="w-75"
                        isDisabled={!canCreate}
											/> */}
                        <CustomSelect
                          id="role"
                          name="role"
                          options={option.map(cat => ({
                            value: cat.role_id.toString(),
                            label: cat.role_name
                          }))}
                          value={selectedValue}
                          isClearable
                          onChange={(selectedOption) => {
                            setSelectedValue(selectedOption);

                            if (selectedOption?.value) {
                              dispatch(fetchRolesAccessRights(selectedOption.value));
                            } else {
                              // ✅ when cleared
                              setData([]);
                              setExpanded({});
                              setSelectAllChecked(false);
                            }
                          }}
                          placeholder="Choose role"
                          className="w-50"
                        />
										</div>

										{/* Square Switch with inside label */}
                    
										<div
											className="col-md-6"
											style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between'
											}}
										>
											<div className="select-toggle-container">
												<div
													className={`oval-toggle ${selectAllChecked ? "unselect-active" : "select-active"}`}
													onClick={() => onSwitchChange({ target: { checked: !selectAllChecked } })}
												>
													<div className={`toggle-side left ${!selectAllChecked ? "active" : ""}`}>
													Select All
													</div>
													<div className={`toggle-side right ${selectAllChecked ? "active" : ""}`}>
													Deselect All
													</div>
												</div>
											</div>

                      {canCreate && (
                        <Button
                          type="submit"
                          className="btn button-submit"
                          onClick={handleSave}
                          >
                          <i className="fas fa-paper-plane me-1" /> Submit
                        </Button>
                      )}
											
										</div>
                    
									</Row>
								</CardHeader>
                {canCreate && (
                  <CardBody className="bg-gradient-to-br from-gray-50 via-white to-gray-100 rounded-2xl w-full p-3">
                    
                    <div className="table-responsive react-table w-100">
                    <Table hover responsive className="permission-table"> {/* Removed 'bordered' */}
                      <thead className="bg-gradient table-light text-uppercase fw-semibold small shadow-sm">
                      <tr>
                        <th className="text-start py-3 px-3 w-40">Permission</th>
                        <th className="text-center py-3 px-2">View</th>
                        <th className="text-center py-3 px-2">Create</th>
                        <th className="text-center py-3 px-2">Modify</th>
                        <th className="text-center py-3 px-2">Approve</th>
                        <th className="text-center py-3 px-2">Delete</th>
                      </tr>
                      </thead>
                      <tbody>
                      {data?.map((item) => renderRow(item))}
                      </tbody>
                    </Table>
                    </div>
                  </CardBody>
                )}
							</Card>
						</Row>
					</div>
                </Container>
            </div>
        </React.Fragment>
    )
}


export default RolesAccessRights;